<template>
    <div class="auth-content">
        <div class="row m-0 h-100">
            <!-- left section image -->
            <div class="col-md-6 d-md-flex d-none p-3 bg-authentication minh-100" style="flex: 1">
                <div class="d-flex justify-content-center align-items-center auth-text pt-4">
                    <div v-if="form === 'login'" class="row text-center">
                        <h4 class="auth-title">Sign In</h4>
                        <p class="auth-subtitle">Please fill in your details to sign in on MagnusTeams.</p>
                        <p class="auth-subtitle --faded">Note: you must enter an email address that is not in use in the MagnusCards app.</p>
                    </div>
                    <div v-if="form === 'register'" class="row text-center">
                        <h4 class="auth-title">Sign Up</h4>
                        <p class="auth-subtitle">
                            With MagnusTeams you will be able to support Heroes who are using the MagnusCards app to be more independent.
                        </p>
                    </div>
                    <div v-if="form === 'reset'" class="row text-center">
                        <h4 class="auth-title">Forgot your Magnus<span style="font-weight: normal">Teams</span>
                            Password?</h4>
                        <p class="auth-subtitle">Don't worry, I'm on it.</p>
                        <p class="auth-subtitle --faded">Just let me know your email address, and I'll send over recovery instructions.</p>
                    </div>
                    <div v-if="form === 'recover'" class="row text-center">
                        <h4 class="auth-title">Reset your Magnus<span style="font-weight: normal">Teams</span> Password!
                        </h4>
                        <p class="auth-subtitle">If you've forgot your password.</p>
                        <p class="auth-subtitle --faded">Enter a new password and confirmation to reset the
                            password.</p>
                    </div>
                    <div v-if="form === 'email_sent'" class="row text-center">
                        <h4 class="auth-title">Email sent!</h4>
                        <p class="auth-subtitle">Please follow the instructions I've prepared to reset your password.</p>
                        <p class="auth-subtitle --faded">
                            If you don't see the email in your inbox, hit "Click here to resend" and let's try again. Don't forget to check your junk mail folder!
                        </p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center align-items-center" style="flex: 1">
                    <img v-if="form === 'login'" draggable="false" alt="branding logo" class="img-fluid"
                         style="height: 180px; padding-right: 120px"
                         src="/assets/img/logo/logo_big_hand_wave.svg">
                    <img v-if="form === 'register'" draggable="false" alt="branding logo" class="img-fluid"
                         style="height: 180px; padding-right: 120px"
                         src="/assets/img/logo/logo_big_hand_peace.svg">
                    <img v-if="form === 'reset' || form === 'recover'" draggable="false" alt="branding logo"
                         class="img-fluid"
                         style="height: 180px; padding-left: 120px"
                         src="/assets/img/logo/logo_big_hand_up.svg">
                    <img v-if="form === 'email_sent'" draggable="false" alt="branding logo" class="img-fluid"
                         style="height: 180px; padding-left: 120px"
                         src="/assets/img/logo/logo_big_hand_ok.svg">
                </div>
            </div>
            <!-- right section-login -->
            <div class="col-md-6 col-12 minh-100 px-0">
                <div class="p-2 minh-100 flexbox-container align-items-center">
                    <div class="auth-form" v-if="form === 'login'">
                        <div>
                            <form-input class="mb-2" inputClass="form-control-lg" type="email" label="Email"
                                        placeholder="Enter your email" v-model="login.email" :v="$v.login.email"
                                        v-on:keyup.enter="signIn()"/>
                            <form-input-password inputClass="form-control-lg" class="mb-2" label="Password"
                                                 placeholder="Enter password" v-model="login.password"
                                                 :v="$v.login.password" v-on:keyup.enter="signIn()"/>

                            <div class="row">
                                <div class="col text-left">
                                    <form-checkbox text="Remember me"></form-checkbox>
                                </div>
                                <div class="col text-right mb-2">
                                    <a @click.prevent="form = 'reset'" class="card-link link-primary" href="#">
                                        Forgot password
                                    </a>
                                </div>
                            </div>
                            <div>
                                <btn class="btn-primary btn-lg w-100 mb-2"
                                     :loading="loading.login"
                                     :disabled="!login.email || !login.password"
                                     v-on:click="signIn()">
                                    Sign in
                                </btn>
                                <btn class="btn-google btn-lg w-100 mb-2"
                                     :loading="loading.login"
                                     @click="AuthProvider('google')">
                                    <inline-svg src="/assets/img/google_icon.svg"/>
                                    Sign in with Google
                                </btn>
                                <btn class="btn-facebook btn-lg w-100 mb-3"
                                     :loading="loading.login"
                                     @click="AuthProvider('facebook')">
                                    <inline-svg src="/assets/img/facebook_icon.svg"/>
                                    Sign in with Facebook
                                </btn>
                            </div>
                            <div class="col text-center auth-gray-text" v-if="form === 'login'">
                                Don't have an account? <a @click.prevent="switchToRegister()"
                                                          class="card-link link-primary" href="#">Sign up</a>
                            </div>
                            <div class="col text-center auth-gray-text" v-if="form === 'register'">
                                Already have an account? <a @click.prevent="switchToLogin()"
                                                            class="card-link link-primary" href="#">Log in</a>
                            </div>
                        </div>
                    </div>
                    <div class="auth-form" v-if="form === 'register'">
                        <div>
                            <form-input inputClass="form-control-lg" class="mb-2" :label="'Name*'"
                                        placeholder="Enter your name" v-model="register.name" :v="$v.register.name"/>
                            <form-input inputClass="form-control-lg" type="email" class="mb-2" :label="'Email*'"
                                        placeholder="Enter your email" v-model="register.email" :v="$v.register.email"/>
                            <form-input-password inputClass="form-control-lg" type="password" :label="'Password*'"
                                                 placeholder="Create a password" v-model="register.password"
                                                 :v="$v.register.password"/>
                            <div class="auth-gray-text mb-2">*Password must be at least 8 characters, one uppercase
                                letter, at least one number and one symbol.
                            </div>
                            <form-input-password inputClass="form-control-lg"
                                                 :class="{'mb-2' : !$v.register.confirm_password.$error}"
                                                 type="password" :label="'Confirm password*'" placeholder=""
                                                 v-model="register.confirm_password" :v="$v.register.confirm_password"/>
                            <div v-if="$v.register.confirm_password && $v.register.confirm_password.$error"
                                 class="text-danger mb-2" style="font-size: 14px;">*Password and confirm password does
                                not match
                            </div>
                            <form-checkbox class="mb-2" v-model="register.terms" :v="$v.register.terms">
                                I agree with the <a style="color: black" href="https://magnusmode.com/terms-and-conditions/" target="_blank">terms and conditions</a>
                            </form-checkbox>
                            <div v-if="$v.register.terms && $v.register.terms.$error"
                                 class="text-danger mb-2" style="font-size: 14px;">*You need to accept terms and conditions
                            </div>

                            <div class="text-center">
                                <btn class="btn-primary btn-lg w-100 mb-2"
                                     :loading="loading.register"
                                     :disabled="!register.name || !register.email || !register.password || !register.confirm_password"
                                     v-on:click="signUp()">Get started
                                </btn>
                                <btn class="btn-google btn-lg w-100 mb-2"
                                     :loading="loading.login"
                                     @click="AuthProvider('google')">
                                    <inline-svg src="/assets/img/google_icon.svg"/>
                                    Sign in with Google
                                </btn>
                                <btn class="btn-facebook btn-lg w-100 mb-3"
                                     :loading="loading.login"
                                     @click="AuthProvider('facebook')">
                                    <inline-svg src="/assets/img/facebook_icon.svg"/>
                                    Sign in with Facebook
                                </btn>

                            </div>
                            <div class="col text-center auth-gray-text" v-if="form === 'register'">
                                Already have an account? <a @click.prevent="switchToLogin()"
                                                            class="card-link link-primary" href="#">Log in</a>
                            </div>
                        </div>
                    </div>
                    <div class="auth-form" v-if="form === 'reset'">
                        <div>
                            <form-input inputClass="form-control-lg" class="mb-2" type="email" label="Email"
                                        placeholder="Enter your email" v-model="reset.email" :v="$v.reset.email"/>
                            <div class="text-center mb-3">
                                <btn :loading="loading.reset"
                                     class="btn-primary btn-lg w-100"
                                     :disabled="!reset.email"
                                     v-on:click="resetPasswordEmail">
                                    Reset password<i class="bx bx-right-arrow-alt" id="icon-arrow"></i>
                                </btn>
                            </div>

                            <div class="text-center d-flex justify-content-center align-items-center">
                                <a class="link-primary auth-gray-text auth-back"
                                   @click.prevent="form = 'login'"
                                   href="#">
                                    <inline-svg class="me-1"
                                                height="12px"
                                                style="margin-bottom: 3px"
                                                src="/assets/img/back_icon.svg"/>
                                    Back to log in
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="auth-form" v-if="form === 'recover'">
                        <div>
                            <form-input-password inputClass="form-control-lg" class="mb-2" type="password"
                                                 label="New password*" placeholder="Enter new password"
                                                 v-model="recover.password" :v="$v.recover.password"/>
                            <form-input-password inputClass="form-control-lg" class="mb-2" type="password"
                                                 label="Confirm new password*" placeholder="Confirm new password"
                                                 v-model="recover.confirm_password" :v="$v.recover.confirm_password"/>

                            <div class="text-center">
                                <btn :loading="loading.recover"
                                     :class="{'loading-btn': loading.recover}"
                                     class="btn-primary btn-lg mb-2 w-100"
                                     v-on:click="recoverPassword()">
                                    Reset<i class="bx bx-right-arrow-alt" id="icon-arrow"></i>
                                </btn>
                            </div>

                            <div class="text-center mb-2">
                                <a @click.prevent="form = 'login'"
                                   class="link-primary"
                                   href="#">Cancel Reset
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="auth-form" v-if="form === 'email_sent'">
                        <div class="text-center">
                            <inline-svg class="mb-3" src="/assets/img/check_icon.svg"/>
                            <div class="text-center mb-3 auth-gray-text">Didn't receive the email?
                                <a @click.prevent="form = 'reset'" class="link-primary" href="#">
                                    Click here to resend
                                </a>
                            </div>
                            <div class="text-center d-flex justify-content-center align-items-center">
                                <a class="link-primary auth-gray-text auth-back" @click.prevent="switchToLogin" href="#">
                                    <inline-svg class="me-1" height="12px" style="margin-bottom: 3px"
                                                src="/assets/img/back_icon.svg"/>
                                    Back to log in
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="wrongAccountTypeModal" height="auto" width="400px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <inline-svg class="mb-2" src="/assets/img/icons/alert-triangle-circle.svg"></inline-svg>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('wrongAccountTypeModal')"></button>
                    </div>
                    <h4 class="modal-title">Oopsie!</h4>
                    <div class="modal-subtitle-gray text-center ps-2 pe-2">
                        Seems like this email address is being used in MagnusCards for a Hero account.
                    </div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center pt-3 pb-4">
                    <div class="modal-subtitle-gray text-center">
                        To create a <b>Caregiver account</b>, use an email address that is not in use in MagnusCards.
                    </div>
                </div>
                <div class="d-flex flex-column gap-2 p-3" >
                    <div class="d-flex flex-row justify-content-between gap-2">
                        <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('removeHeroModal')">Close</btn>
                        <btn class="btn-primary btn-lg flex-1"
                             @click="switchToRegister">
                            Create account
                        </btn>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import FormInput from "/src/components/core/FormInput";
import FormInputPassword from "/src/components/core/FormInputPassword";
import FormCheckbox from "../components/core/FormCheckbox.vue";
import Btn from '/src/components/core/Btn'
import BtnIcon from "@/components/core/BtnIcon.vue";

const {required, sameAs, minLength, email} = require('vuelidate/lib/validators');
import {passwordValidators} from '@/validators';
import {mapState} from 'vuex';
import PasswordValidation from "@/components/core/PasswordValidation.vue";
import {minValue} from "vuelidate/lib/validators";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
    name: 'Auth',
    components: {UserAvatar, PasswordValidation, BtnIcon, FormInput, FormInputPassword, FormCheckbox, Btn},
    data() {
        return {
            form: 'login',
            message: '',
            error: null,
            loading: {
                login: false,
                reset: false,
                recover: false
            },
            login: {
                email: '',
                password: '',
            },
            register: {
                name: '',
                email: '',
                password: '',
                confirm_password: '',
                status: true,
                newsletter: false,
                role: 'caregiver',
                terms: false,
            },
            reset: {
                email: '',
            },
            recover: {
                email: '',
                password: '',
                confirm_password: '',
                reset_token: ''
            },
        }
    },
    validations: {
        login: {
            email: {required: required},
            password: {required: required},
        },
        register: {
            name: {required: required, minLength: minLength(2)},
            email: {required: required, email},
            password: passwordValidators,
            confirm_password: {required, sameAs: sameAs('password')},
            terms: {required: required, minValue: minValue(true)},
        },
        reset: {
            email: {required, email}
        },
        recover: {
            password: {required, minLength: minLength(6)},
            confirm_password: {required, sameAs: sameAs('password')},
        },
    },
    watch: {
        $route(to) {
            if (to.name === 'register') {
                this.form = 'register';
            } else if (to.name === 'login') {
                this.form = 'login';
            } else {
                this.form = to.name;
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },
    created: function () {
        // $('body').removeClass('2-columns');
        // $('body').addClass('bg-full-screen-image blank-page 1-column');
        // $('body').attr('data-col', '1-column');
    },
    mounted: function () {
        if (this.$auth.getToken()) {
            this.$router.push({name: 'home'});
        } else {
            // $('#preloader').fadeOut('slow');
        }
        if (this.$route.name === 'register') {
            this.form = 'register';
        }
        if (this.$route.query.resetToken) {
            this.form = 'recover';
            this.recover.email = this.$route.query.email;
            this.recover.reset_token = this.$route.query.resetToken;
        }
        // if (this.$route.query.confirmToken) {
        //     this.confirmAccount();
        // }
    },
    methods: {
        signIn: function () {
            this.$v.login.$touch();
            if (this.$v.login.$invalid == true) {
                return false;
            }
            this.loading.login = true;
            this.$http.post("/auth/login", this.login)
                .then((res) => {
                    this.loading.login = false;
                    if (res.body.data.token) {
                        this.$store.commit('setUser', res.body.data.user);
                        this.$auth.setToken(res.body.data.token);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        // this.$role.setPermissions(res.body.user.role, res.body.data.user.permission_codes);
                        setTimeout(() => {
                            if (sessionStorage.getItem("caregiver:redirectLoginPathName")) {
                                this.$router.push({
                                    name: sessionStorage.getItem("caregiver:redirectLoginPathName"),
                                    params: JSON.parse(sessionStorage.getItem("caregiver:redirectLoginParams")),
                                    query: JSON.parse(sessionStorage.getItem("caregiver:redirectLoginQuery"))
                                });
                            } else {
                                this.$router.push({name: 'home'});
                            }
                        }, 200);
                    }
                })
                .catch((error) => {
                    this.loading.login = false;
                    if (error.body.status_code === 403) {
                        this.$modal.show('wrongAccountTypeModal')

                    }
                    console.log('error', error.body.status_code)
                });
        },
        signUp: function () {
            this.$v.register.$touch();
            if (this.$v.register.$invalid == true) {
                return false;
            }
            this.error = '';
            this.message = '';
            this.loading.register = true;
            this.$http.post("/auth/signup", this.register)
                .then((res) => {
                    this.loading.register = false;
                    if (res.body.data.token) {
                        this.$store.commit('setUser', res.body.data.user);
                        this.$auth.setToken(res.body.data.token);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        // this.$role.setPermissions(res.body.data.users.role, res.body.data.users.user.permission_codes);
                        this.$router.push({name: 'home'});
                    } else {
                        this.message = res.body.message;
                        this.register = {
                            name: '',
                            email: '',
                            password: '',
                            confirm_password: '',
                            terms: false,
                        }
                        this.$v.register.$reset();
                        this.form = 'login'
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    this.loading.register = false;
                });
        },
        AuthProvider(provider) {
            var self = this
            this.$socialAuth.authenticate(provider).then(response => {
                self.SocialLogin(provider,response)
            }).catch(err => {
                console.log({err:err})
            })
        },

        SocialLogin(provider,response) {
            this.$http.post(`/auth/login/${provider}/callback`, response)
                .then(res => {
                    if (res.body.token) {
                        this.$store.commit('setUser', res.body.user);
                        this.$auth.setToken(res.body.token);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        this.$router.push({name: 'home'});
                    } else {
                        this.message = res.body.message;
                        this.register = {
                            name: '',
                            email: '',
                            password: '',
                            confirm_password: '',
                            terms: false,
                        }
                        this.$v.register.$reset();
                        this.form = 'login'
                    }
                }).catch(err => {
                console.log({err:err})
            })
        },

        resetPasswordEmail: function () {
            this.$v.reset.$touch();
            if (this.$v.reset.$invalid == true) {
                return false;
            }
            this.loading.reset = true;
            this.$http.post("/auth/forgot/password", this.reset)
                .then(function (res) {
                    this.loading.reset = false;
                    this.form = 'email_sent'
                })
                .catch(function (res) {
                    this.loading.reset = false;
                })
        },
        recoverPassword: function () {
            this.$v.recover.$touch();
            if (this.$v.recover.$invalid == true) {
                return false;
            }
            this.loading.recover = true;
            this.$http.post("/auth/reset", this.recover)
                .then(function (res) {
                    this.loading.recover = false;
                    this.form = "login";
                    this.$router.replace(this.$router.currentRoute.path);
                })
                .catch(function (res) {
                    this.loading.recover = false;
                })
        },
        switchToLogin() {
            if (this.$router.name === 'login') {
                return;
            }
            this.$router.push({name: 'login'});
            this.form = 'login';
        },
        switchToRegister() {
            this.$modal.hide('wrongAccountTypeModal');
            this.$router.push({name: 'register'});
            this.form = 'register';
        },
        confirmAccount() {
            this.loading.login = true;
            this.$http.post("/auth/confirm-account", {
                confirmation_token: this.$route.query['confirmToken']
            })
                .then(function (res) {
                    this.loading.login = false;
                    this.$router.replace(this.$router.currentRoute.path);
                })
                .catch(function (res) {
                    this.loading.login = false;
                })
        },
    },
}
</script>

